import React, { useState, useRef } from "react";

export default function CategoryBanner({ userImage, username, overlays, imagePositionMap, usernamePositionMap }) {
    const [selectedCategory, setSelectedCategory] = useState("singer");
    const bannerRef = useRef(null);

    const handleCategoryChange = (e) => {
        setSelectedCategory(e.target.value);
    };

    const handleDownload = () => {
        import("html2canvas").then((html2canvas) => {
            if (bannerRef.current) {
                html2canvas.default(bannerRef.current,{useCORS:true}).then((canvas) => {
                    const link = document.createElement("a");
                    link.download = `${username}_${selectedCategory}_banner.png`;
                    link.href = canvas.toDataURL("image/png");
                    link.click();
                });
            }
        });
    };

    const currentOverlay = overlays[selectedCategory];
    const overlayStyleImage = imagePositionMap[selectedCategory] || {};
    const overlayStyleUsername = usernamePositionMap[selectedCategory] || {};

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
            {/* Dropdown + Download */}
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                <select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    style={{
                        padding: "1.5rem 2.5rem",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                        color: "#333",
                        backgroundColor: "#fff",
                        outline: "none",
                        transition: "border-color 0.2s, box-shadow 0.2s",
                    }}
                    onFocus={(e) => {
                        e.target.style.borderColor = "#3B82F6";
                        e.target.style.boxShadow = "0 0 0 2px rgba(59, 130, 246, 0.4)";
                    }}
                    onBlur={(e) => {
                        e.target.style.borderColor = "#ccc";
                        e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)";
                    }}
                >
                    <option value="singer">Singer</option>
                    <option value="fashion">Fashion</option>
                    <option value="dancer">Dancer</option>
                    <option value="standup">Standup</option>
                </select>

                <button
                    onClick={handleDownload}
                    style={{
                        padding: "1rem 1.5rem",
                        backgroundColor: "#2563EB",
                        color: "#fff",
                        borderRadius: "8px",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "500",
                        fontSize: "1.875rem",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                        transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#1D4ED8")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "#2563EB")}
                >
                    Download
                </button>
            </div>

            {/* Banner */}
            <div
                ref={bannerRef}
                style={{
                    position: "relative",
                    width: "600px",
                    height: "600px",
                    margin: "0 auto",
                    backgroundColor: "#333",
                    overflow: "hidden",
                    borderRadius: "12px",
                }}
            >
                {/* Overlay */}
                {currentOverlay && (
                    <img
                        src={currentOverlay}
                        alt={`${selectedCategory} overlay`}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            zIndex: 1,
                        }}
                    />
                )}

                {/* User Image */}
                {userImage && (
                    <img
                        src={userImage}
                        alt={username}
                        crossOrigin="anonymous"
                        style={{
                            position: "absolute",
                            zIndex: 3,
                            ...overlayStyleImage,
                        }}
                    />
                )}

                {/* Username */}
                {username && (
                    <div
                        style={{
                            position: "absolute",
                            zIndex: 3,
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "1.5rem",
                            textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
                            ...overlayStyleUsername,
                        }}
                    >
                        {username}
                    </div>
                )}
            </div>
        </div>
    );
}
